export const LOAD_PARTNER_MONTHLY_OBLIGATIONS_SUCCEEDED = "LOAD_PARTNER_MONTHLY_OBLIGATIONS_SUCCEEDED";
